/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React, { createContext, useContext, useEffect, useState } from "react";

import { debugLog } from "../../helpers/debug";
import { useAuth } from "../auth";
import { useFirebase } from "../Firebase";
import { getObjFromLink, transformCollectionSnap } from "../helpers";
import { ServiceM8Provider } from "./serviceM8";

const IntegrationsContext = createContext({});

export const IntegrationsProvider = ({ children }) => {
  const firebase = useFirebase();
  const { claims } = useAuth();

  const [integrations, setIntegrations] = useState();

  useEffect(() => {
    if (!claims?.companyLink) {
      debugLog(
        "[IntegrationsProvider] No companyLink, skipping integrations listener"
      );

      return () => {};
    }

    debugLog("[IntegrationsProvider] Setting up integrations listener");

    return firebase
      .integrations(getObjFromLink(claims.companyLink).id)
      .onSnapshot(
        snap => setIntegrations(transformCollectionSnap(snap)),
        err => debugLog(err)
      );
  }, [
    claims.companyLink,
    firebase,
  ]);

  return (
    <IntegrationsContext.Provider
      value={{
        integrations,
      }}
    >
      <ServiceM8Provider>{children}</ServiceM8Provider>
    </IntegrationsContext.Provider>
  );
};

export const IntegrationsConsumer = IntegrationsContext.Consumer;

export const useIntegrations = () => useContext(IntegrationsContext);
